import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useSelector, useDispatch, shallowEqual} from 'react-redux'
import {RootState} from '../../../../setup'
import _ from 'lodash'
import {setResponse} from '../../../redux/ResponseModalSlice'

const ResponseModal: React.FC = () => {
  const [show, setShow] = useState(false)
  const [content, setContent] = useState<React.ReactNode>(null)
  const [device, setDevice] = useState<any>(null)
  const response = useSelector((state: RootState) => state.responseModal.response)
  const allDevices: any = useSelector<RootState>(({device}) => device.allDevices, shallowEqual)
  const dispatch = useDispatch()

  useEffect(() => {
    if (response && !_.isEmpty(response)) {
      setShow(true)
      const d: any = allDevices.find((d: any) => d.DeviceId === response.DeviceId)
      setDevice(d)

      setContent(
        <React.Fragment>
          <div style={{display: 'flex', flexWrap: 'wrap'}}>
            <label className='form-label fs-6 m-0'>
              Device {d?.VehicleNo} was successfully rebooted.
            </label>
          </div>
        </React.Fragment>
      )
    }
  }, [response])

  useEffect(() => {
    if (show === false) {
      dispatch(
        setResponse({
          response: {},
        })
      )
    }
  }, [show])

  const handleClose = () => {
    setShow(false)
  }

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body>
        <div className='d-flex w-100 align-items-center justify-content-between mb-5'>
          <div className='d-flex gap-5 '>
            <label className='form-label fs-6 text-dark m-0'>{device?.VehicleNo}</label>
            <label className='form-label fs-6 m-0 text-gray-600'>{device?.DeviceId}</label>
          </div>
          <button className='btn btn-link p-0' type='button' onClick={handleClose}>
            <i
              className='fa fa-times-thin fa-2x'
              aria-hidden='true'
              style={{fontSize: '2em', padding: 0, verticalAlign: 'unset'}}
            ></i>
          </button>
        </div>
        <div className='line-break w-100 my-5' style={{backgroundColor: '#EFF2F5', height: 1}} />
        {content}
      </Modal.Body>
    </Modal>
  )
}

export default ResponseModal
